import SichernConnectApiClient from '@/apiClient/SichernConnect'
import {
  SET_MODAL_VISIBLE,
  SET_LINKING_STATUS_CODE,
  SET_REQUEST_LOADING,
  SET_HAS_ERROR_LINKING,
  SET_SUCCESS_LINKING,
  SET_API_ERROR_EMAIL,
  SET_API_ERROR_PASSWORD,
  SET_API_ERROR_GLOBAL,
  CLEAR_API_ERRORS
} from './mutations-types'

var sichernConnectApi = new SichernConnectApiClient()

var emailApiCodes = [
  'USER_INVALID_EMAIL',
  'USER_UNIQUE_EMAIL_EXCEPTION',
  'EMAIL_VALUE_IS_INVALID',
  '00070',
  '00074'
]

var passwordApiCodes = ['00069', '00071']

export default {
  requestLinkingStatus ({ commit, rootState }) {
    var rememberLater = localStorage.getItem('vc_remember_later')
    if (rememberLater && rememberLater === '1') {
      return
    }
    var status = (rootState.user && rootState.user.sichern_connect) || 'not_available'
    commit(SET_LINKING_STATUS_CODE, status)
    commit(SET_MODAL_VISIBLE, status === 'ready_to_link')
    if (status === 'in_progress') {
      commit(SET_SUCCESS_LINKING, true)
    }
  },

  async setLinkAccount ({ commit, rootState }) {
    try {
      await sichernConnectApi.enroll(rootState.user && rootState.user.id)
      commit(SET_SUCCESS_LINKING, true)
      commit(SET_HAS_ERROR_LINKING, false)
      commit(SET_MODAL_VISIBLE, false)
      commit(CLEAR_API_ERRORS)
    } catch (error) {
      console.error('Error linking account:', error)
      commit(SET_HAS_ERROR_LINKING, true)
      commit(SET_SUCCESS_LINKING, false)
      throw error
    }
  },

  cancelLinking ({ commit }) {
    commit(SET_MODAL_VISIBLE, false)
    commit(CLEAR_API_ERRORS)
    commit(SET_REQUEST_LOADING, false)
    localStorage.setItem('vc_remember_later', '1')
  },

  setApiErrorCode ({ commit }, code) {
    commit(CLEAR_API_ERRORS)
    if (!code) return

    if (emailApiCodes.includes(code)) {
      commit(SET_API_ERROR_EMAIL, code)
      return
    }
    if (passwordApiCodes.includes(code)) {
      commit(SET_API_ERROR_PASSWORD, code)
      return
    }
    commit(SET_API_ERROR_GLOBAL, code)
  },

  clearApiErrors ({ commit }) {
    commit(CLEAR_API_ERRORS)
  },

  clearApiError ({ commit }, field) {
    if (field === 'emailCode') commit(SET_API_ERROR_EMAIL, null)
    else if (field === 'passwordCode') commit(SET_API_ERROR_PASSWORD, null)
    else if (field === 'globalCode') commit(SET_API_ERROR_GLOBAL, null)
  },

  setRequestLoading ({ commit }, value) {
    commit(SET_REQUEST_LOADING, value)
  }
}
